<ziro-toast></ziro-toast>
@if (!isLoading && !isLoadingLanguage) {
  <div id="angular-testability"></div>
}
@if (!isLoadingLanguage) {
  <router-outlet></router-outlet>
}
